module.exports = __webpack_public_path__ + "fonts/duo_70x70.e2baf65d97a5d6f2c083e14d4717ccf4.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/duo_70x70.png
// module id = 754
// module chunks = 9